import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex h-[24px] items-center rounded-lg border px-2.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/70',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/70',
        outline: 'border-border text-foreground hover:border-border/70',
        warn: 'border-transparent bg-warn text-warn-foreground hover:bg-warn/70',
        // Status variants
        'status-draft': 'border-transparent bg-tertiary-pink text-tertiary-violet-foreground-light',
        'status-scheduled': 'border-transparent bg-tertiary-violet text-tertiary-violet-foreground',
        'status-sending': 'border-transparent bg-tertiary-orange text-tertiary-orange-foreground',
        'status-paused': 'border-transparent bg-tertiary-pink text-tertiary-pink-foreground',
        'status-delivered': 'border-transparent bg-tertiary-teal text-tertiary-teal-foreground',
        'status-suspended': 'border-transparent bg-destructive text-destructive-foreground'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
